function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 13L5.5 18H63.5L59 13H9Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 4L12.5 8H54.5L50.5 4H15.5Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5 8H54.5L59 13H9L12.5 8Z",
  fill: "#495E80"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.5 18H63.5L71 26H0L5.5 18Z",
  fill: "#495E80"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5 0H47L50.5 4H15.5L18.5 0Z",
  fill: "#495E80"
});

var SvgGameFinishLine = function SvgGameFinishLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 71,
    height: 26,
    viewBox: "0 0 71 26",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGameFinishLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game-finish-line.ee2b5319.svg";
export { ForwardRef as ReactComponent };